import React, { Component } from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/";
import AppRoute from "./routes/route";

// layouts
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import "./assets/scss/custom.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Import fackbackend Configuration file
// Activating fake firebase
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

import { getToken, onMessageListener } from "./firebase";
import { Toast, ToastBody, ToastHeader } from "reactstrap";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNotification: false,
      notificationData: {},
    };
    this.getLayout = this.getLayout.bind(this);

    getToken();
    onMessageListener()
      .then((message) => {
        this.setState({
          showNotification: true,
          notificationData: message.notification,
        });
        window.setTimeout(() => {
          this.setState({ showNotification: false });
        }, 2000);
        console.log(message);
      })
      .catch((err) => console.log("failed: ", err));
  }

  onShowAlert = () => {
    this.setState({ showNotification: true }, () => {
      window.setTimeout(() => {
        this.setState({ showNotification: false });
      }, 2000);
    });
  };

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  render() {
    const Layout = this.getLayout();
    return (
      <React.Fragment>
        {/* <button type="button" className="btn btn-primary" onClick={()=>{this.onShowAlert()}} >show Alert</button> */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: "99999",
          }}
        >
          <Toast isOpen={this.state.showNotification}>
            <ToastHeader>{this.state.notificationData.title}</ToastHeader>
            <ToastBody>
              <p style={{ marginRight: "30px" }}>
                {this.state.notificationData.body}
              </p>
            </ToastBody>
          </Toast>
        </div>
        <Switch>
          {publicRoutes.map((route, idx) => (
            <AppRoute
              path={route.path}
              exact={route.exact}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <AppRoute
              path={route.path}
              exact={route.exact}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
            />
          ))}
        </Switch>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
